import { h, defineComponent } from 'vue';

export interface ImageLinkProps {
  url?: string;
  imgSrc: string;
  classes?: string;
}

export type ImagelessLinkProps = Omit<ImageLinkProps, 'imgSrc'>;

export const ImageLink = defineComponent({
  name: 'ImageLink',
  props: ['url', 'imgSrc', 'classes'],
  setup(props) {
    return function render() {
      return h('a', {
        attrs: {
          href: props.url,
          target: '_blank',
          class: props.classes,
        },
      }, [
        h('img', {
          attrs: {
            src: props.imgSrc,
          },
        }),
      ]);
    };
  },
});

export function imageLink(props: ImageLinkProps) {
  return h(ImageLink, { props });
}

export function appStoreBadge(props: ImagelessLinkProps = {}) {
  return imageLink({ ...props, url: process.env.VUE_APP_IOS_APP_URL, imgSrc: '/images/app-store-badge.svg' });
}

export function googlePlayStoreBadge(props: ImagelessLinkProps = {}) {
  return imageLink({ ...props, url: process.env.VUE_APP_ANDROID_APP_URL, imgSrc: '/images/google-play-badge.svg' });
}
